import {CARD_TYPES} from 'common/requestDetails/constants.js';
import Simple from './Simple';
import ContainerItem from './ContainerItem';
import StaffingBundled from './StaffingBundled';

export {Simple};

export const Cards = {
  [CARD_TYPES.SIMPLE]: Simple,
  [CARD_TYPES.SIMPLE_HIRING]: StaffingBundled,
  [CARD_TYPES.STAFFING_BUNDLED]: StaffingBundled,
  ContainerItem: ContainerItem,
};
export default Cards;
